// extracted by mini-css-extract-plugin
module.exports = {"switch":"StatusInput-module_switch_dbf59"};